import React from 'react';
import { Stack, Box } from '@mui/material';
import AppLayout from '../../layout/app.layout';
import Channels from '../../components/form-elements/channels.component';
import TotalSubscriber from '../../components/reports/web-total-subscriber.component';
import WebSubscriberSummary from '../../components/reports/web-subscriber-summary';
import ListWebSubscriptionsOverview from '../../components/reports/list-web-subscriptions-overview.component';
import { getDate } from '../../utils/datetime.util';

const WebSubscribersView = () => {
  const pageTitle = 'Analytics / Web / Subscribers';
  const [selectedChannel, setSelectedChannel] = React.useState(null);
  const [filters, setFilters] = React.useState({
    startDate: getDate(-7),
    endDate: getDate(0),
  });

  return (
    <AppLayout pageTitle={pageTitle}>
      <Box
        sx={{
          transition: 'margin 0.3s ease, width 0.3s ease',
          width: '100%',
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ px: 0, py: 2 }}
        >
          <Box
            sx={{
              width: '30%',
            }}
          >
            <Channels
              id="dr_channel"
              name="dr_channel"
              label="Select Channel"
              defaultValue={null}
              onChange={(v) => setSelectedChannel(v)}
              sx={{ width: '100%', my: 1 }}
            />
          </Box>
        </Stack>
        <TotalSubscriber
          selectedChannel={selectedChannel ? selectedChannel.id : 0}
          startDate={filters.startDate}
          endDate={filters.endDate}
          updateFilters={(newFilters) => setFilters(newFilters)}
        />
        <WebSubscriberSummary
          selectedChannel={selectedChannel ? selectedChannel.id : 0}
          startDate={filters.startDate}
          endDate={filters.endDate}
        />
        <ListWebSubscriptionsOverview
          selectedChannel={selectedChannel ? selectedChannel.id : 0}
        />
      </Box>
    </AppLayout>
  );
};

export default WebSubscribersView;
